<i18n
  src="@/locales/views/agro_exporter/finances/container_outcomes/show_process.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>

<template>
  <div class="mt-4">
    <h1 class="page-title">
      <i class="fa-solid fa-container-storage"></i
      ><span class="space-icon"></span>
      {{ $t("labels.containers_title") }}
    </h1>

    <div class="mt-6 flex flex-row justify-between">
      <div class="panel-plain-label space-x-4">
        <badge-default
          :label="
            containers.length + ' ' + $t('labels.total_number_containers')
          "
        />
        <badge-default
          :label="
            containers_paid + ' ' + $t('labels.total_number_containers_paid')
          "
        />
      </div>
      <button type="button" @click.prevent="downloadReport()" class="btn-white">
        <i
          :class="[
            'fa-solid',
            downloading ? 'fa-sync fa-spin' : 'fa-file-excel'
          ]"
        ></i
        ><span class="space-icon"></span
        >{{ $t("labels.download_button") }}
      </button>
    </div>

    <div class="mt-2 flex flex-col">
      <ag-grid-vue
        style="height: 650px"
        class="ag-theme-alpine"
        @grid-ready="onGridReady"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="containers_custom"
      >
      </ag-grid-vue>
    </div>
  </div>
</template>

<script>
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue3";
import Requester from "@/views/agro_exporter/requesters/finances/container_outcomes/show_process.js";

export default {
  name: "AEFinancesContainerIncomesShowProcessContainers",
  components: { AgGridVue },
  data() {
    return {
      downloading: false,
      defaultColDef: {
        sortable: true,
        filter: true,
        floatingFilter: true
      },
      columnDefs: [
        {
          headerName: this.$t("model.container.week"),
          field: "week",
          filter: "agNumberColumnFilter",
          width: 50
        },
        {
          headerName: this.$t("model.container.container_code"),
          field: "container_code",
          filter: true,
          cellRendererSelector: params => {
            const agro_exporter_id = this.agro_exporter_id;
            const agro_exporter_process_id = this.agro_exporter_process_id;
            const GoToLink = {
              template: `<span @click="this.goToShowContainer()" class="link">${params.value}</span>`,
              methods: {
                goToShowContainer: function () {
                  this.$router.push({
                    name: this.routeName("show_container"),
                    params: {
                      agro_exporter_id: agro_exporter_id,
                      agro_exporter_process_id: agro_exporter_process_id,
                      container_id: params.data.id
                    }
                  });
                }
              }
            };
            return {
              component: GoToLink
            };
          }
        },
        {
          headerName: this.$t("model.container.customer"),
          field: "customer.name",
          filter: true
        },
        {
          headerName: this.$t("model.container.provider"),
          field: "provider_name",
          filter: true
        },
        {
          headerName: this.$t("labels.num_org_invoices"),
          field: "num_org_invoices_label",
          filter: true,
          cellRendererSelector: params => {
            const total = params.data.num_org_invoices;
            const paid = params.data.num_org_invoices_paid;
            let label = "<p></p>";
            if (total) {
              label = `<p>${paid}/${total} <yes-no-label :value="${
                total == paid
              }" yes="Pagado" no="No pagado"></yes-no-label></p>`;
            }
            return { component: { template: label } };
          }
        }
      ]
    };
  },
  props: {
    containers: {
      type: Array
    },
    agro_exporter_id: {},
    agro_exporter_process_id: {}
  },
  computed: {
    containers_paid: function () {
      return this.containers.filter(
        container =>
          container.num_org_invoices > 0 &&
          container.num_org_invoices == container.num_org_invoices_paid
      ).length;
    },
    containers_custom: function () {
      return this.containers.map(container => {
        return {
          ...container,
          num_org_invoices_label: this.paidLabel(container)
        };
      });
    }
  },
  methods: {
    downloadReport: async function() {
      this.downloading = true;
      try {
        var response = await Requester.downloadRepXlsx(
          this.agro_exporter_id,
          this.agro_exporter_process_id
        );
        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", "Facturas_y_pagos.xlsx");
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
      this.downloading = false;
    },
    paidLabel: function (container) {
      let total = container.num_org_invoices;
      let paid = container.num_org_invoices_paid;
      if (!total) return "";
      return total == paid
        ? this.$t("labels.paid")
        : [`${paid}/${total}`, "No pagado"];
    },
    sizeToFit() {
      this.gridApi.sizeColumnsToFit({
        defaultMinWidth: 150
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.sizeToFit();
    }
  }
};
</script>
